export const filter = (client, searchString) => {
	if (client.team)
		return [client.name, client.surname, client.team.name].find(s => s.includes(searchString));
	else
		return [client.name, client.surname].find(s => s.includes(searchString));
};
